import Header from 'modules/header/farm/main';
import useGetThisYearCultivation from './hooks/useGetThisYearCultivation';
import WithCultivation from './withCultivation';
import NoCultivation from './noCultivation';
import {useCookies} from 'react-cookie';
import WithNotification from './withNotification';

const SelectCultivation = () => {
  const {cultivations, cultivationsisLoading} = useGetThisYearCultivation();
  const [cookie] = useCookies(['cultivationGuid']);
  return (
    <>
      <Header title="انتخاب کشت" />
      {!cultivationsisLoading && (
        <div className="mt-8 px-3">
          {cookie && cookie.cultivationGuid ? (
            <WithNotification
              CultivationArea={cookie?.cultivationGuid?.area}
              guid={cookie?.cultivationGuid?.guid}
              harvestDateTime={cookie?.cultivationGuid?.harvestDateTime}
              subProduct={cookie?.cultivationGuid?.subProduct}
              mahsulGuid={cookie?.cultivationGuid?.product_guid}
            />
          ) : cultivations && cultivations?.length > 0 ? (
            <WithCultivation cultivations={cultivations} />
          ) : (
            <NoCultivation />
          )}
        </div>
      )}
    </>
  );
};

export default SelectCultivation;
